import { RosterRef } from '../../components/invitations/models/invitation.model';

/**
 * The mock organizations, shared by every mock feature.
 *
 * This used to live in the invitations seed as ROSTERS_SEED, which meant invitations owned
 * "what organizations exist" — fine until a second feature needed the same list. Two seeds
 * would let the app show two contradictory sets of organizations, so there is one.
 *
 * `availableKeys` is the invitations notion (scoring keys). Inventory tracks its own
 * `{individual, group, team}` balances and ignores this field; whether the two are really the
 * same pool is an open product question, so they are deliberately not merged here.
 */
export const ORGS_SEED: RosterRef[] = [
  { id: 'r1', name: 'Acme Corporation Worldwide Holdings', availableKeys: 6 },
  { id: 'r2', name: 'Globex Innovation & Research Division', availableKeys: 40 },
  { id: 'r3', name: 'Initech Systems & Consulting Group', availableKeys: 0 },
  { id: 'r4', name: 'Northwind Traders International Logistics & Distribution', availableKeys: 25 },
  { id: 'r5', name: 'Umbrella Pharmaceuticals Research Collective', availableKeys: 12 },
  { id: 'r6', name: 'Stark Industries Advanced Technology Group', availableKeys: 8 },
];
